import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import AddFavourite from "../../utility/js/addFav";
import documentService from "./document-upload-service";
import EncryptUtility from "../../utility/js/encrypt-utility";
import router from "../../../router/router";
export default {
  data: () => ({
    name: "DocumentMastersAccountDetails",
    userId: EncryptUtility.localStorageDecrypt("userID"),
    route: "",
    mainPage: "",
    subPage: "",
    subPageUrl: "",
    appPageName: "",
    pageName: "",
    backSlash: true,
    backSlashParent: true,
    totalRecords: 0,
    accountMastersDetails: [],
    accountNameList: [],
    managerName: "",
    backupAccountManager: "",
    searchFilter: "",
    selectedDocumentType: 0,
    documentTypeList: [],
    selectedPersonnel: 0,
    personnelList: [],
    selectedDocumentStatus: 0,
    documentStatusList: [],
    documentDetailsData: [],
    pageCount: 0,
    page: 1,
    documentDetailHeaders: [
      { text: "Document No", value: "document_number", class: "primary customwhite--text" },
      { text: "Document Type", value: "type_name", class: "primary customwhite--text" },
      { text: "Title", value: "title", class: "primary customwhite--text" },
      { text: "Author", value: "author_name", class: "primary customwhite--text" },
      { text: "Revision", value: "revision", class: "primary customwhite--text" },
      { text: "Engineer", value: "engineer_name", class: "primary customwhite--text" },
      { text: "Engineering Approval", value: "is_engineer_approved", class: "primary customwhite--text" },
      { text: "Management Approval", value: "is_manager_approved", class: "primary customwhite--text" },
      { text: "Status", value: "status_name", class: "primary customwhite--text" },
      { text: "Applicable Personnel", value: "applicable_personnel", class: "primary customwhite--text" },
      { text: "Actions", value: "actions", class: "primary customwhite--text" },
    ],
  }),
  async created() {
    let dataSimple = await AddFavourite.getPageAction(this.userId, "document-account-list");
    this.route = this.$route.path.replace("/", "").split("/")[0];
    let data = await AddFavourite.getParentPageAction(this.userId, this.route);
    this.actionList = dataSimple.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.subPageUrl = data.subPageUrl;
    this.appPageName = data.appPageName;
    this.loadDropdowns();
    if (this.$route.params.accountMastersDetails !== undefined) {
      this.accountMastersDetails = JSON.parse(atob(this.$route.params.accountMastersDetails));
      this.managerName = this.accountMastersDetails?.manager_name;
      this.backupAccountManager = this.accountMastersDetails?.backup_manager_name;
      this.selectedAccountName = this.accountMastersDetails?.account_id;
      this.getDocumentData(1);
    }
  },
  mounted() {
    router.afterEach((to) => {
      if (
        !to.path.includes("document-account-add") &&
        !to.path.includes("document-account-edit") &&
        !to.path.includes("document-account-list") &&
        !to.path.includes("document-account-details")
      ) {
        EncryptUtility.localStorageRemoveItem("accountMastersDetails");
      }
    });
  },
  methods: {
    //Reset function
    resetFunction() {
      this.totalRecords = 0;
      this.accountNameList = [];
      this.searchFilter = "";
      this.selectedDocumentType = 0;
      this.documentTypeList = [];
      this.selectedPersonnel = 0;
      this.personnelList = [];
      this.selectedDocumentStatus = 0;
      this.documentStatusList = [];
      this.documentDetailsData = [];
      this.pageCount = 0;
      this.page = 1;
      this.loadDropdowns();
      this.getDocumentData(1);
    },
    async loadDropdowns() {
      let masterObj = {
        pass: 0,
        user_id: parseInt(this.userId),
      };
      let masterData = await documentService.documentLoadMasters("post", masterObj, false);
      if (masterData.message !== "NA") {
        this.accountNameList = masterData.document_account;
        this.documentTypeList = masterData.document_type;
        this.documentStatusList = masterData.document_status;
        this.personnelList = masterData.applicable_personnel;
      }
    },
    //Get data table data
    async getDocumentData(page) {
      let obj = {
        page_number: page,
        page_size: 20,
        account_key: parseInt(this.selectedAccountName),
        search_string: this.searchFilter.toUpperCase(),
        status_key: this.selectedDocumentStatus !== null ? parseInt(this.selectedDocumentStatus) : 0,
        type_key: this.selectedDocumentType !== null ? parseInt(this.selectedDocumentType) : 0,
        sort_column: "document_id",
        sort_direction: "DESC",
        applicable_personnel_key: this.selectedPersonnel == null ? 0 : parseInt(this.selectedPersonnel),
      };
      let data = await documentService.documentListView("post", obj, false);
      if (data.message !== "NA" && data.length !== 0) {
        this.totalRecords = data[0].total_records;
        this.pageCount = data[0].total_pages;
        const newArr = data.map((obj) => {
          return {
            ...obj,
            applicable_personnel: JSON.parse(obj.applicable_personnel),
          };
        });
        this.documentDetailsData = newArr;
      } else {
        this.totalRecords = 0;
        this.pageCount = 0;
        this.documentDetailsData = [];
      }
    },
    //Get Search data
    getSearchData() {
      if (this.searchFilter.length > 3) {
        this.getDocumentData(1);
      }
    },
    // Clear all filters and refresh table
    clearFilters() {
      this.searchFilter = "";
      this.selectedDocumentType = 0;
      this.selectedPersonnel = 0;
      this.selectedDocumentStatus = 0;
      this.getDocumentData(1);
    },
    //Add Document Click
    addDocumentClick() {
      if (this.accountMastersDetails.length !== 0) {
        this.$router.push({
          name: "documentMastersAccountAdd",
          params: {
            accountMastersDetailsAdd: btoa(JSON.stringify(this.accountMastersDetails)),
          },
        });
      } else {
        this.$router.push("/document-account-add");
      }
    },
    //View Document
    viewDocument(item) {
      this.$router.push({
        name: "documentMastersAccountDetails",
        params: {
          accountMastersDetailsID: btoa(item.document_id.toString()),
        },
      });
    },
    //Edit Document
    editDocument(item) {
      this.$router.push({
        name: "documentMastersAccountEdit",
        params: {
          accountMastersEditID: btoa(item.document_id.toString()),
        },
      });
    },
    documentRedirect() {
      this.$router.push("/document-masters");
    },
  },
  components: {
    breadcrumbComp,
  },
};
